import { render, staticRenderFns } from "./FlowHeader.vue?vue&type=template&id=36d6c51a&scoped=true&"
import script from "./FlowHeader.vue?vue&type=script&lang=js&"
export * from "./FlowHeader.vue?vue&type=script&lang=js&"
import style0 from "./FlowHeader.vue?vue&type=style&index=0&id=36d6c51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d6c51a",
  null
  
)

export default component.exports